import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import {
  GrantAcceptanceTemplateService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePutGrantAcceptanceTemplateEditableTable = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void,
  setSaveErrors: (boolean: boolean) => void
): UseMutationResult<
  Array<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        GrantAcceptanceTemplateService.putApiAwardApiAppGrantAcceptanceTemplateDataFromTable(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.isSuccess) {
          toast.success(
            <ToastComponent label='Success' message={`Grant Acceptance Template Edited.`} />
          );
          // await queryClient.invalidateQueries('getParticipantBrokerList');
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        setSaveErrors(err ? true : false);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutGrantAcceptanceTemplateEditableTable;
